import React, { Component } from 'react'
import { connect } from 'react-redux'
import * as actions from '../../../Cereal/actions'
import { Field } from 'redux-form'
import {
  renderSelectField
} from '../../fieldRenderers'

class Biotecnologia extends Component {
  constructor (props) {
    super(props)
    this.renderBiotecnologias = this.renderBiotecnologias.bind(this)
    this.onSelect = this.onSelect.bind(this)
  };

  componentDidMount () {
    const { cereal } = this.props
    this.props.requestBiotecnologiasByCereal(cereal)
  };

  onSelect (biotecnologia) {
    if (biotecnologia) {
      this.props.setBiotecnologia(biotecnologia.target.value)
    }
  }

  renderBiotecnologias () {
    const {
      biotecnologias
    } = this.props

    /*   if ((biotecnologias instanceof Array) && biotecnologias.length < 1) { */
    if ((biotecnologias instanceof Array)) {
      biotecnologias.unshift({ nombre: 'NO ALEGA' })
    }
    return biotecnologias.map(biotecnologia =>
      (
        <option
          value={biotecnologia.nombre}
          key={biotecnologia.nombre}
        >
          {biotecnologia.nombre}
        </option>
      ))
  };

  render () {
    const {
      isRequesting
    } = this.props

    return (
      <Field
        onChange={this.onSelect}
        name='biotecnologiaCereal'
        label='Biotecnologia'
        component={renderSelectField}>
        {!isRequesting ? this.renderBiotecnologias() : null}
      </Field>
    )
  }
}

const mapStateToProps = (state) => ({
  isRequesting: state.cereal.isRequestingBiotecnologias,
  biotecnologias: state.cereal.biotecnologias
})

const withRedux = connect(mapStateToProps, actions)

export default withRedux(Biotecnologia)
